import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import storage from "../../../../firebaseConfig.js"
import {ref,uploadBytesResumable, getDownloadURL} from "firebase/storage"
import LinearProgress from '@material-ui/core/LinearProgress';

import {
  Box,
  Button,
  Avatar,
  TextField,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { NetworkContext } from '../../../../context/NetworkContext';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'
   
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  input: {
    display: 'none',
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));
function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};
const BrokerDetails = props => {
  const { open, onClose, onUpdate,usercontent,masters, viewtype, className, ...rest } = props;
  const [percent, setPercent] = React.useState(0);
  const [error, setError] = React.useState({error: false,
    message: {
      
    }});
  const classes = useStyles();
  const [basicInfo, setBasicInfo] = React.useState({});
  const defaultProps = {
    options:[
                
               
     
    ],
    getOptionLabel: (option) => option.name
    // filterOptions: (options, state) => {
  //   let newOptions = [];
  //   options.forEach((option) => {
  //     if (option.title.includes(state.inputValue)) {
  //       newOptions.push(option);
  //     }
  //   });
  //   return newOptions.filter((movie) => !movies.includes(movie));
  // }
};

const produtoptions = {
  options:[
              
             
    {
      "id":1,
      "name":"Product 1",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    },
    {
      "id":2,
      "name":"Product 2",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    },
    {
      "id":3,
      "name":"Product 3",
      "createdAt":"17 Nov 2022 10:20 AM",
      "status":true
    }
  ],
  getOptionLabel: (option) => option.name

};
const [movies, setMovies] = useState([]);

  const initialValues = {
    languages:[],
    brokers_name : '',
    contact_number : '',
    company_name:'',
    gst_number:'',
    city: '',
    priority: '',
    imageurl: '',
    products : []
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [subcommodity, setSubcommodity] = useState([]);
  const [selectedlangs, setSelectedlangs] = React.useState([]);
  const [masterlanguages, setMasterLanguages] = React.useState([]);
  const [values, setValues] = useState({
    ...initialValues
  });

  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
        }

        const storageRef = ref(storage, `/product/${value.name}`)
        const uploadTask = uploadBytesResumable(storageRef, value);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
          const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          
          // update progress
          setPercent(percent);
          },
          (err) => console.log(err),
          () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            console.log("imageurl"+url)
            setValues(values => ({
              ...values,
              ['imageurl']: url
            }));
          });
          }
          );
     
    }

    fun({
      ...state, [name]: value, ...extra
    })
  }


  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  const handleClear = () => {
    setValues({ ...initialValues });
  };



  React.useEffect(() => {

    if(usercontent && usercontent.id)
    {
      if(usercontent.languages.length > 0)
      {
        let langs = [];
    }
      if(values.products.length > 0)
      {
        setMovies([...values.products])
      }
      
      setValues({
        ...usercontent
      })
    }
 }, [usercontent]);
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };
  React.useEffect(() => {
    if(movies)
    {
      setValues({
        ...values,
        products : movies
      })
    }
 }, [movies]);
 React.useEffect(() => {
  if(masters)
  {
    
  }
}, [masters]);

  const handleSubmit = event => {
    event.preventDefault();
    let iserror = false
    let messagecontent = {}
    if(!values.languages || values.languages.length == 0)
    {
      iserror = true
      messagecontent['languages'] = "Please enter choose atleast one language"
    }
  
    if(!values.brokers_name || values.brokers_name.length == 0)
    {
      iserror = true
      messagecontent['brokers_name'] = "Please enter broker's name"
    }
    if(!values.city || values.city.length == 0)
    {
      iserror = true
      messagecontent['city'] = "Please broker's city"
    }
    //values['languages'] = masterlanguages
   
   
    if(iserror)
    {
    let errorcontent = {
      error : true,
      message : messagecontent
    }

    setError(errorcontent)
  }else{
    values['languages'] = selectedlangs && selectedlangs.length > 0 ? selectedlangs : values.languages 
    let errorcontent = {
      error : false,
      message : messagecontent
    }
    setError(errorcontent)
    onUpdate && onUpdate(values);
  }
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const handleChange = (event) => {
    if(event.target.value == 'All')
    {
      if(event.target.checked)
      {
        setValues(values => ({
          ...values,
          ['languages']: ['All','Tamil','English','Telugu']
        }));
      }else{
        setValues(values => ({
          ...values,
          ['languages']: []
        }));
      }
    }else{
      if(event.target.checked)
      {
        var array = [...values.languages]
        if(array.length === 2)
        {
          array.push('All')
        }
        array.push(event.target.value)
        setValues(values => ({
          ...values,
          ['languages']: array
        }));
      }else{
        var array = [...values.languages]; // make a separate copy of the array
         if(array.length > 1)
         {
          var allindex = array.indexOf('All')
          if(allindex !== -1)
          {
            array.splice(allindex, 1)
          }

          var index = array.indexOf(event.target.value)
          if (index !== -1) {
            array.splice(index, 1);
           
            setValues(values => ({
              ...values,
              ['languages']: array
            }));
          }
        }
      }
    }
    //setChecked(event.target.checked);
  };
  React.useEffect(() => {
    if(masters.languages)
    {
      let langs_arr = [...masters.languages]
      langs_arr.splice(0,1)
      setMasterLanguages([
        ...langs_arr
      ])
      if(viewtype==2)
      {
        masters['languages'] = [
          
          ...langs_arr
        ]
      
      }
    }
  },[masters])
  const handleoptionchange = type => (event, value) => {
    
    if(type === 'languages' && value.length > 0 && value[0].name === 'All')
    {
      let langs = [];

      masters.languages.map((element)=> {
        if(element.name != 'All')
        {
          langs.push(element)

        }
      })
      setSelectedlangs([...langs])
      masters['languages'] = [
        {
          id : 0,
          name : "All"
        }
      ]

      setValues(values => ({
        ...values,
        [type]: value
      }));
    
    }else {
      if(type === 'languages')
      {
        if(value.length > 0)
        {
          setSelectedlangs([...value])
  
          masters['languages'] = [
            ...masterlanguages
          ]
        }else{
          masters['languages'] = [
            {
              id : 0,
              name : "All"
            },
            ...masterlanguages
          ]
          setSelectedlangs([])
        }
      }
    
   
    if(type == 'commodity')
    {
      if(value)
      {
        fetchsubcommodity(value.value)
        
      }else{
        setSubcommodity([])
        setValues(values => ({
          ...values,
          [subcommodity]: null
        }));
      }
    }
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  }

  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  async function fetchsubcommodity(commodityID)
  {
    let bodycontent = {
      commodityID
    }

    let commodity_arr = await sendNetworkRequest('/fetchsubcommodity', {}, bodycontent,false)
    setSubcommodity(commodity_arr)
  }
  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
          <Grid container row xs={12}>
          
          <Grid container xs={9} spacing={2}>
        
        <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('brokers_name')}
                        error={error?.message?.brokers_name}
                        helperText={error?.message?.brokers_name}
                        value={values.brokers_name}
                       label="Broker Name"
                      />
        </Grid>
        {/* <Grid item xs={12}>
        <TextField
                       variant="outlined"
                       margin="dense"
                       fullWidth
                       autoComplete="off"
                       id="vendordeliverydays"
                       name="vendordeliverydays"
                       onChange={handleinputchange('company_name')}
                       value={values.company_name}
                      label="Company Name"
                      />
        </Grid> */}
        {/* <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('gst_number')}
                        value={values.gst_number}
                       label="GST No"
                      />
        </Grid> */}
        <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('contact_number')}
                        value={values.contact_number}
                       label="Contact Number"
                      />
        </Grid>
        <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('priority')}
                        value={values.priority}
                       label="Listing Priority"
                      />
        </Grid>
        <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('city')}
                        error={error?.message?.city}
                        helperText={error?.message?.city}
                        value={values.city}
                       label="City"
                      />
        </Grid>

        <Grid item xs={12}>
        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        autoComplete="off"
                        id="vendordeliverydays"
                        name="vendordeliverydays"
                        onChange={handleinputchange('imageurl')}
                        value={values.imageurl}
                       label="image"
                      />
        </Grid>
           <Grid item xs={12}>
           {masters.languages && (values.languages || viewtype == 1)  && <Autocomplete

              options={masters.languages}
              getOptionLabel={(option) => option.name}
              multiple
              id="combo-box-demo"
              margin="dense"
              fullWidth
              value={values.languages}
              getOptionSelected={(option, value) => option.name === value.name}
                  filterSelectedOptions
             // disabled={viewtype == 2 ? true : false}
               onChange={handleoptionchange('languages')}
              renderInput={(params) => <TextField {...params} label={"Languages"} fullWidth margin="dense"
              error={error?.message?.languages}
              helperText={error?.message?.languages}
              variant="outlined" />}
            /> }
        </Grid>
        <Grid item xs={12}>
        {masters.products && (values.products || viewtype == 1)  && <Autocomplete
              options = {masters.products}
              multiple
              id="combo-box-demo"
              margin="dense"
              fullWidth
              filterSelectedOptions
              value={movies}
              getOptionSelected={(option, value) => `${option.name} - ${option.qty}` === `${value.name} - ${value.qty}`}
              onChange={(e, newValue) => setMovies(newValue)}
              getOptionLabel={(option) => `${option.name} - ${option.qty}`}
           //   disabled={viewtype == 2 ? true : false}
              renderTags={() => null}
              //onChange={handleoptionchange('products')}
              renderInput={(params) => <TextField {...params} label={"Products"} fullWidth margin="dense" variant="outlined" />}
            /> }
        </Grid>
        <Grid item xs={12}>
        <List>
        {values.products.map((movie) => (
          <ListItem key={movie.name}>
            <ListItemText primary={`${movie.name} - ${movie.qty}`} />
            <IconButton
              key={movie.id}
              aria-label="delete"
              onClick={() => {
                setMovies(() => values.products.filter((m) => m.id !== movie.id));
              }}
            >
              <HighlightOffIcon />
            </IconButton>
          </ListItem>
        ))}
      </List>
        </Grid>
          </Grid>
          <Grid container xs={3}>
          <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  spacing={2}
                  style={{ display: "grid" }}
                >
                  <Grid style={{ margin: "auto" }}>
                    <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                      onChange={e => setData(e.target.files[0], "image", setBasicInfo, basicInfo)}
                    />
                    {values.imageurl ? <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label> : <label htmlFor="icon-button-file">
                      <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                    </label>}
                    {percent == 0 || percent == 100 && <LinearProgressWithLabel value={percent} />}
                  </Grid>
                </Grid>
                </Grid>
          </Grid>
          
         
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

BrokerDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default BrokerDetails;
